import React, { useState } from 'react'

import { Card, Col, Container, Row } from 'react-bootstrap'

import { useTranslation } from 'react-i18next'
import FairyTaleAlert from '../../components/fairytale-alert'
import { CREATE_FORM_ATTRIB_DATA } from './constants'
import FairytaleFormComponent from '../../components/fairytale-form'
import { Campaign } from '../../types/ads'
import useFairyTaleClubAdsCrudHooks from '../../hooks/useFairyTaleClubAppAdsCrudHooks'
import fairytaleYup from '../../yup'

export default function EditCampaign({ campaign }: { campaign: Campaign }) {
  const { t: tforms } = useTranslation(['formFields'])
  const { t: tpagetexts } = useTranslation(['pageTexts'])
  const { editAppCampaign } = useFairyTaleClubAdsCrudHooks(campaign.app_id)
  const [showAlert, setShowAlert] = useState<boolean>(false)

  const CAMPAIGN_SCHEMA = fairytaleYup.object().shape({
    description: fairytaleYup.string().required(tforms('fieldIsRequired')),
    title: fairytaleYup.string().required(tforms('fieldIsRequired')),
    ad_duration: fairytaleYup.string().required(tforms('fieldIsRequired')),
  })
  const _handleSubmit = async (
    values: Campaign,
    { setStatus, setErrors, setSubmitting, resetForm }: any,
  ) => {
    values.ad_duration = Number(values.ad_duration)
    const result = (await editAppCampaign(values)) as { data: any }
    if (result.data) {
      setShowAlert(true)
      setTimeout(() => setShowAlert(false), 10000)
    } else {
      // @ts-ignore
      const message = result.error || t('somethingWentWrong')
      setStatus({ success: false })
      setErrors({ submit: message })
      setSubmitting(false)
    }
  }

  return (
    <React.Fragment>
      <Container fluid className="p-0">
        <h1 className="h3 mb-3">{tpagetexts('appPageSubtitle')}</h1>
        <Row>
          <Col>
            <Card>
              <Card.Body>
                <FairytaleFormComponent
                  formProps={CREATE_FORM_ATTRIB_DATA}
                  editMode={false}
                  onSubmit={_handleSubmit}
                  formSchema={CAMPAIGN_SCHEMA}
                  initialFormValues={campaign}
                />
                <FairyTaleAlert
                  variant="success"
                  message={tforms('campaignUpdateSuccess')}
                  heading=""
                  show={showAlert}
                  name="edit-campaign"
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  )
}
